<template>
    <div class="uk-container uk-container-expand">
            <router-link :to="{path: '/admin/livraison/retour/create'}" class="btn btn-round mt-3 border-0" style="background-color:#FFAB0E; color:#fff;" type="button" uk-toggle="target: #create_commande" v-if="getRole == 5 || getRole == 4"><i class="fa fa-plus"></i>Enregistrer un retour</router-link>
        <div class="uk-card uk-card-default  uk-width-1-1@m mt-3 p-2">
            <!-- <input type="text" class="uk-input" v-model="search" placeholder="Rechercher..."> -->
            <h4>Liste des retours</h4>
            <div class="uk-overflow-auto">
                <table class="uk-table uk-table-striped">
                <thead>
                   <tr>
                        <th>N°</th>
                        <th>Nom du livreur</th>
                        <!-- <th>Valeur du coli</th> -->
                        <th>Nom de la boutique</th>
                        <th>Lieu de la livraison</th>
                        <th>N° du destinataire</th>
                        <th>Motif du retour</th>
                        <th>Relance ou Retour</th>
                        <th>Date de relance</th>
                        <th>Commande du</th>
                        <th>Statut</th>
                        <th v-if="getRole == 5 || getRole == 4">Actions</th>
                    </tr> 
                </thead>
                <tbody>
                    <!-- <div v-for="retour in filterRetour" :key="retour.key"> -->
                    <tr v-for="(retour,item) in retours" :key="retour.id" :class="retour.type == 'annuler' ? 'uk-text-danger' : ''">
                        <td>{{item+1}}</td>
                        <!-- <td>{{retour.nature_coli}}</td>
                        <td>{{retour.valeur_coli}} FCFA</td> -->
                        <td>{{retour.nom_livreur}}</td>
                        <td>{{retour.nom_boutique}}</td>
                        <td>{{retour.lieu_livraison}}</td>
                        <td>{{retour.phone_destinataire}}</td>
                        <td>{{retour.motif_retour}}</td>
                        <td>{{retour.relance_retour}}</td>
                        <td>{{retour.date_relance}}</td>
                        <td>{{retour.created_at}}</td>
                        <td>{{ retour.statut_retour }}</td>
                        <td v-if="getRole == 5 || getRole == 4">
                            <router-link :to="{path: '/admin/livraison/retour/edit/' + retour.key }" v-bind:tooltip=" retour.id"  class="btn btn-default mr-1 uk-box-shadow-large">
                                <span class="" style="color: #5F5F5F" uk-icon="icon:pencil; ratio: 0.8"></span>
                            </router-link>
                            <button @click="removeBoutique(retour.key)" class="btn btn-default uk-box-shadow-large">
                                <span class="" style="color: #5F5F5F" uk-icon="icon:trash; ratio: 0.8"></span>
                            </button>
                        </td>
                    </tr>
                    <!-- </div> -->
                </tbody>
            </table>
            </div>
        </div>
    </div>
</template>
<script>
import { db, dbstore, auth } from '../../main';
export default {
    data(){
        return{
            // search:'',
            retours:[],
            retour: {
                nom_livreur: "",
                nature_coli: "",
                valeur_coli: "",
                nom_boutique: "",
                lieu_livraison: "",
                phone_destinataire: "",
                motif_retour: "",
                id_colis: "",
                relance_retour: "",
                created_at: "",
                date_relance: "",
                statut_retour: "",
            }
        }
    },
    methods: {
        removeBoutique(key){
            let go = this
            dbstore.collection('livraison_retour').doc(key).delete()
                .doc(this.$route.params.id)
                .set(this.boutique)
                .then(() => {
                    console.log("Boutique supprimée !");
                    go.$router.push({path:'/admin/boutiques'});
                    Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Boutique supprimée !',
                    showConfirmButton: true,
                    timer: 4000,
                    allowOutsideClick: false,
                    })
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    // computed: {
    //     filterRetour(){
    //         return this.retours.filter(retour.created_at.includes(this.search))
    //     }
    // },
    created () {
        this.getRole =  this.$store.getters.user.data.role;
        dbstore.collection('livraison_retour')
        .orderBy("created_at", 'desc')
        .onSnapshot((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                this.retours.push({
                    nom_livreur: doc.data().nom_livreur,
                    nature_coli: doc.data().nature_coli,
                    valeur_coli: doc.data().valeur_coli,
                    nom_boutique: doc.data().nom_boutique,
                    lieu_livraison : doc.data().lieu_livraison,
                    phone_destinataire : doc.data().phone_destinataire,
                    motif_retour : doc.data().motif_retour,
                    id_colis: doc.data().id_colis,
                    relance_retour : doc.data().relance_retour,
                    created_at : doc.data().created_at,
                    date_relance : doc.data().date_relance,
                    statut_retour : doc.data().statut_retour,
                    key: doc.id,
                });
            });
        });

  },
}
</script>